var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLcGroupIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.6 6C7.3675 6 8.8 4.6568 8.8 3C8.8 1.3432 7.3675 0 5.6 0C3.8325 0 2.4 1.3432 2.4 3C2.4 4.6568 3.8325 6 5.6 6ZM6.8675 7.125H4.3325C1.93925 7.125 0 8.94375 0 11.1867C0 11.6367 0.388 12 0.8665 12H10.3325C10.8125 12 11.2 11.6367 11.2 11.1867C11.2 8.94375 9.26 7.125 6.8675 7.125ZM11.9775 7.5H10.1313C11.28 8.38359 12 9.70547 12 11.1867C12 11.4867 11.905 11.7633 11.75 12H15.2C15.6425 12 16 11.6625 16 11.2289C16 9.17813 14.21 7.5 11.9775 7.5ZM10.8 6C12.3475 6 13.6 4.82578 13.6 3.375C13.6 1.92422 12.3475 0.75 10.8 0.75C10.1722 0.75 9.599 0.950508 9.132 1.27758C9.42 1.79602 9.6 2.37656 9.6 3C9.6 3.8325 9.30175 4.59703 8.81025 5.21977C9.3175 5.7 10.02 6 10.8 6Z",
    fill: "#0083FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLcGroupIcon);
export default __webpack_public_path__ + "static/media/lc-group-icon.448cd2ecc0a90d06774297427f151c85.svg";
export { ForwardRef as ReactComponent };